import {ChangeDetectionStrategy, Component} from '@angular/core';
import {BaseFieldType} from '../base-field-type';
import {NbCheckboxModule} from "@nebular/theme";
import {FormlyModule} from "@ngx-formly/core";
import {NgForOf, NgIf} from "@angular/common";

@Component({
  templateUrl: './checkbox-multi-property.component.html',
  standalone: true,
  imports: [
    NbCheckboxModule,
    FormlyModule,
    NgIf,
    NgForOf
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckboxMultiPropertyComponent extends BaseFieldType {
  onChange(value, checked) {
    if (this.props.type === 'array') {
      this.formControl.patchValue(checked
        ? [...(this.formControl.value || []), value]
        : [...(this.formControl.value || [])].filter((
          o => o !== value)));
    } else {
      this.formControl.patchValue(Object.assign({}, this.formControl.value, {[value]: checked}));
    }
    this.formControl.markAsTouched();
  }

  isChecked(option) {
    const value = this.formControl.value;
    return value && (this.props.type === 'array'
      ? (value.indexOf(option.value) !== -1)
      : value[option.value]);
  }

}
